RivalIQ.module('enums', function (enums, App, Backbone, Marionette, $, _) {

    'use strict';

    enums.account = {

        conversionStatus: {
            TRIAL: 1,
            COMPED: 2,
            PAID: 3,
            CHURNED: 4
        },

        conversionStatuses: [
            {
                id: 1,
                name: 'Trial'
            },
            {
                id: 2,
                name: 'Comped'
            },
            {
                id: 3,
                name: 'Paid'
            },
            {
                id: 4,
                name: 'Churned'
            }
        ],

        status: {
            REGISTRATION: 2,
            ACTIVE: 3
        },

        statuses: {
            registration: {
                id: 2,
                name: 'registration'
            },
            active: {
                id: 3,
                name: 'active'
            }
        },

        roles: [
            {
                id: 1,
                name: 'Owner'
            },
            {
                id: 2,
                name: 'Full'
            },
            {
                id: 3,
                name: 'Read-Only'
            }
        ]
    };
});
